import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, Button } from 'antd';

import { setWarningModalVisibility, updateConfigStatus } from '@store/serviceIntegrations/existingIntegrations/actions';
import { actionSelector, warningModalVisibilitySelector } from '@store/serviceIntegrations/existingIntegrations/selectors';
import { displayMessage } from './utils';
import { StyledPara } from '../styled';

function WarningModal() {
  const dispatch = useDispatch();
  const visible = useSelector(warningModalVisibilitySelector);
  const action = useSelector(actionSelector);
  const {
    actionType,
  } = action;
  const displayText = displayMessage(actionType);
  let text = '';
  let actionText = '';

  switch (actionType) {
    case 0: {
      text = 'Delete Service';
      actionText = 'delete';
      break;
    }
    case 1: {
      text = 'Disable Service';
      actionText = 'disable';
      break;
    }
    case 2: {
      text = 'Enable Service';
      actionText = 'enable';
      break;
    }
    default: {
      text = 'Enable Service';
      actionText = 'enable';
      break;
    }
  }

  const onConfirm = () => {
    dispatch(updateConfigStatus());
    dispatch(setWarningModalVisibility(false));
  };

  const onCancel = () => {
    dispatch(setWarningModalVisibility(false));
  };

  const footerButtons = [
    (
      <Button
        key="discard"
        onClick={onCancel}
      >
        Discard
      </Button>
    ),
    (
      <Button
        key="save"
        type='primary'
        onClick={onConfirm}
      >
        Confirm
      </Button>
    ),
  ];

  return (
    <Modal
      title={text}
      width="550px"
      open={visible}
      onCancel={onCancel}
      footer={footerButtons}
    >
      <StyledPara>
        <p>
          Are you sure you want to
          {` ${actionText} `}
          the config?
        </p>
        {displayText}
      </StyledPara>
    </Modal>
  );
}

export default WarningModal;
